import { YesObject } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import SelectAndLinkButton from 'site/Renderer/components/DataTables/components/TableActions/SelectAndLinkButton'
import { targetComponents } from 'site/Renderer/components/SelectAndLink/SelectAndLink.constants'
import { ArrayFieldValue, GroupedFieldValues } from '../../types'
import { Actions, Container } from './Field.styles'

type RelationDataFieldProps = {
  objectclassUuid: string
  name?: string
  label?: string
  children: React.ReactNode
  groupedFieldValues: GroupedFieldValues
  displayActions?: boolean
  groupPosition: number
  selectedOptions: ArrayFieldValue
  selectAndLinkTargetPath?: string
}

const RelationDataField = ({
  name,
  label,
  objectclassUuid,
  groupedFieldValues,
  displayActions,
  groupPosition,
  children,
  selectAndLinkTargetPath
}: RelationDataFieldProps) => {
  const selectAndLinkOptions = useMemo(() => {
    const targetField = name || ''
    const targetGroup = String(groupPosition)
    const selectedOptions = (groupedFieldValues[targetGroup]?.[targetField]
      ?.value ?? []) as ArrayFieldValue

    return {
      targetField,
      targetGroup,
      targetComponent: targetComponents.FILTER_FIELDS as const,
      selectedOptions: selectedOptions as YesObject[]
    }
  }, [name, groupPosition, groupedFieldValues])

  return (
    <Container {...{ displayActions }}>
      {children}
      {displayActions && (
        <Actions>
          <SelectAndLinkButton
            selectAndLinkOptions={selectAndLinkOptions}
            objectclassUuid={objectclassUuid}
            objectClassTitle={label}
            hideSelectAndLinkAction={false}
            selectAndLinkTargetPath={selectAndLinkTargetPath}
            variant='icon'
          />
        </Actions>
      )}
    </Container>
  )
}

export default RelationDataField
